export enum AuthCodeStatus {
  PENDING,
  VALIDATING,
  VALID,
  INVALID,
  LOGIN_ERROR,
  CODE_EXPIRED,
  RESEND_CODE_START_REQUEST,
  RESEND_CODE_SUCCESS,
  RESEND_CODE_ERROR,
}
